import { render, staticRenderFns } from "./LocalExterno.vue?vue&type=template&id=f3db4b38&"
import script from "./LocalExterno.vue?vue&type=script&lang=js&"
export * from "./LocalExterno.vue?vue&type=script&lang=js&"
import style0 from "./LocalExterno.vue?vue&type=style&index=0&id=f3db4b38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports